import React from 'react';

import { IOrbitIconProps } from './OrbitNewChatIcon';

/**
 * Send glyph of the full-page composer (`6410:9297`): an 18 x 18 box holding two stroked vectors,
 * the shaft `6410:9298` (10.88 long at y 9) and the head `6410:9299` (4.5 x 9 at x 9.75), both
 * `#FFFFFF` at 1.3125. The drawn white becomes `currentColor` so the button owns the ink.
 */
const OrbitSendIcon: React.FC<IOrbitIconProps> = ({ width = 18, height = 18, className }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 18 18"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    focusable="false"
    aria-hidden="true"
    data-testid="orbit-icon-send"
  >
    <path
      d="M3.375 9H14.25M9.75 4.5L14.25 9L9.75 13.5"
      stroke="currentColor"
      strokeWidth={1.3125}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default OrbitSendIcon;
